import { adminReducer } from '@modules/admin/Admin.Dux'
import { adminRoomsReducer } from '@modules/admin/rooms/Rooms.dux'
import { alertReducer } from '@modules/admin/alert/Alert.dux'
import { confirmationAlertReducer } from '@modules/kernel/confirmationAlert.Dux'
import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form/dist/redux-form'
import professional from './modules/admin/schedules-legacy/dux/professional'
import auth from './modules/auth/auth.Dux'

export const CLEAR_STORE = 'CLEAR_STORE'
export const clearStore = () => ({
  type: CLEAR_STORE,
})

const appReducer = combineReducers({
  auth,

  form: formReducer,
  confirmationAlert: confirmationAlertReducer,

  admin: adminReducer,
  adminRooms: adminRoomsReducer,

  professional,
  alert: alertReducer,
})

export const rootReducer = (state, action) => {
  if (action.type === CLEAR_STORE) {
    state = undefined
  }
  return appReducer(state, action)
}

export default rootReducer
